function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.485 5.71491L15.2969 1.63827H1.6731L8.485 5.71491ZM15.2969 11.3917V3.27655L8.485 7.31509L1.6731 3.27655V11.3917H15.2969ZM15.2969 0C15.7484 0 16.1334 0.165097 16.4521 0.495292C16.7974 0.825487 16.97 1.20648 16.97 1.63827V11.3917C16.97 11.8235 16.7974 12.2045 16.4521 12.5347C16.1334 12.8649 15.7484 13.03 15.2969 13.03H1.6731C1.22163 13.03 0.823271 12.8649 0.478028 12.5347C0.159343 12.2045 0 11.8235 0 11.3917V1.63827C0 1.20648 0.159343 0.825487 0.478028 0.495292C0.823271 0.165097 1.22163 0 1.6731 0H15.2969Z",
  fill: "#07003D",
  fillOpacity: 0.3
});

var SvgOwnerEmail = function SvgOwnerEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOwnerEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/owner_email.6aed6b47.svg";
export { ForwardRef as ReactComponent };